import React from 'react';
import { Translate } from 'react-redux-i18n';

class CalculateResult extends React.Component {
  renderItem = (firstTitle, value, lastTitle) => {
    return (
      <div className="mt-10">
        <span>
          <Translate value={firstTitle} />
        </span>
        <input className="input-method" value={value} disabled />
        <span>
          <Translate value={lastTitle} />
        </span>
      </div>
    );
  };

  render() {
    const {
      infoError,
      eoyStockPrice,
      ennOfNextYearStockPrice,
      estimateStockPrice,
      numOneFirstResult,
      numOneLastResult,
      numTwoFirstResult,
      numTwoLastResult,
      isValidate,
      calculate,
    } = this.props;

    return (
      <div className="left-group">
        <div className="middle-button">
          <button
            disabled={isValidate}
            className={
              isValidate
                ? `valuation-tool-button-de-active`
                : `valuation-tool-button`
            }
            onClick={calculate}
          >
            <Translate value={'valuation.buttonCalculate'} />
          </button>
        </div>

        <div className="left-result-langer-wrap">
          <div className="error-info">
            <Translate value={infoError} />
          </div>
          <div className="wrap-result-long">
            <span className="result-title">
              <Translate value={'valuation.resultTitle'} />
            </span>
            <div className="line-under-title" />
            {eoyStockPrice !== undefined &&
              this.renderItem(
                numOneFirstResult,
                eoyStockPrice,
                numOneLastResult,
              )}
            {ennOfNextYearStockPrice !== undefined &&
              this.renderItem(
                numTwoFirstResult,
                ennOfNextYearStockPrice,
                numTwoLastResult,
              )}
            {estimateStockPrice !== undefined &&
              this.renderItem(
                numOneFirstResult,
                estimateStockPrice,
                numOneLastResult,
              )}
          </div>
        </div>
      </div>
    );
  }
}

export default CalculateResult;
